export default __webpack_public_path__ + "media/images/features/ana/details-be03c9bccd91502da0b09d2ac0f7210b.png";